/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ location: NonNullable<unknown>, device: NonNullable<unknown> }} Notifications_Security_Sign_In_Body_ExpandedInputs */

const en_notifications_security_sign_in_body_expanded = /** @type {(inputs: Notifications_Security_Sign_In_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign-in from ${i?.location} using ${i?.device}.`)
};

const pt_br2_notifications_security_sign_in_body_expanded = /** @type {(inputs: Notifications_Security_Sign_In_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acesso de ${i?.location} usando ${i?.device}.`)
};

/**
* | output |
* | --- |
* | "Sign-in from {location} using {device}." |
*
* @param {Notifications_Security_Sign_In_Body_ExpandedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_security_sign_in_body_expanded = /** @type {((inputs: Notifications_Security_Sign_In_Body_ExpandedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Security_Sign_In_Body_ExpandedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_security_sign_in_body_expanded(inputs)
	return pt_br2_notifications_security_sign_in_body_expanded(inputs)
});